import React from "react";
import { Typography, Tooltip } from "antd";
const { Text } = Typography;

const Address = (props) => {
  const { record, ellipsis } = props;
  const street = record["address.street"]
    ? record["address.street"] + " " + record["address.house_number"]
    : "";
  const address =
    record["address.city"] !== undefined
      ? record["address.city"] + ", " + street
      : street;

  return ellipsis ? (
    <Tooltip className="content" placement="topLeft" title={address}>
      {address}
    </Tooltip>
  ) : (
    <Text>{address}</Text>
  );
};

export default Address;
